import { Directive, Input, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { WorkStation } from '../work-station'
import { WorkStationFilter, WorkStationService } from '../work-station.service'

@Directive({
  selector: '[appWorkStationSelect]',
})
export class WorkStationSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  @Input()
  public disabledWorkStations: WorkStation[] = []
  private select = inject<ElderSelectComponent<WorkStation>>(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const workStationService = inject(WorkStationService)
    this.select.displayProperty = 'name'
    this.select.placeholder = 'shopfloor.workstations.add'
    this.select.isOptionDisabledFn = (station) =>
      this.disabledWorkStations.some((ws) => ws.id === station.id)
    this.select.dataSource = workStationService
    this.select.sorts = [new Sort('id', 'asc')]
  }

  @Input()
  public set facilityId(facilityId: string) {
    if (facilityId) {
      this.select.filters = [WorkStationFilter.facility(facilityId)]
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public clear(): void {
    this.select.clear(undefined)
  }
}
